module.exports = __webpack_public_path__ + "static/media/Polygon-darkPink.f03403d0.svg";